import { render } from "./NossosServicos.vue?vue&type=template&id=143fb36c&scoped=true"
import script from "./NossosServicos.vue?vue&type=script&lang=js"
export * from "./NossosServicos.vue?vue&type=script&lang=js"

import "./NossosServicos.vue?vue&type=style&index=0&id=143fb36c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143fb36c"]])

export default __exports__